'use strict';

import * as Onyx from '../lib/onyx.min.js';

export default class Bubbles extends Onyx.Entity {
    constructor(position = [0,0,0], scale = 1, rotation = 0){
        super();

        this.transform.translateTo(position[0], position[1], position[2]);

        this.addComponent(new Onyx.ParticleEmitter({
            count: 50,
            life: 10000,
            rate: 200,
            velocity: [0.0, 1.0, 0.0],
            spriteOptions: {
                src: "res/textures/bubble.png",
                pixelsPerUnit: 0.006,
                lighting: 1
            }
        }));
    }

    onSpawn(...args){
        super.onSpawn(...args);

        // Wobble
        let t = new Onyx.Tween();
        t.easeIn(this.transform, "y", this.transform.y + 150, 1000, () => {
            // this.parentScene.remove(this);

            this.parentScene.setModulate((scene, dt, progress) => {
                var v = 7 + ((Math.PI-0)*((-Math.cos(progress*Math.PI)/2) + 0) / 10);

                for(var i = 0; i < this.components[0].particles.length; i++){
                    this.components[0].particles[i].transform.scaleTo(v, v, 1);
                }
            }, 100);
        });
        this.parentScene.addComponent(t);

        // Prepare the bubbles for 600 frames in
        for(var i = 0; i < 600; i++){
            this.update(1000 / 16, this.parentScene);
        }
    }

    update(...args){
        super.update(...args);

        this.components[0].offset[0] = Math.random() * 4000;
        this.components[0].offset[2] = Math.random() * 2000;
    }
}